/**
 * Tenant-stable business week. Must match App\Support\BusinessWeek default.
 * Translation locale must not change THIS_WEEK / lastWeek period bounds.
 *
 * 0 = Sunday, 1 = Monday, 6 = Saturday (date-fns weekStartsOn).
 */
export const BUSINESS_WEEK_STARTS_ON: 0 | 1 | 6 = 1

export function businessWeekStartsOn(): 0 | 1 | 6 {
  return BUSINESS_WEEK_STARTS_ON
}
